import { ReactComponent as IconShirtHeart } from "assets/svg/shirt-heart.svg";
import { SurveyTemplate } from "../../types";
import { getContestDefaults } from "../helpers";

export const favoriteMerchItems: SurveyTemplate = {
  icon: <IconShirtHeart />,
  title: "Favorite Merch Items",
  description:
    "Build interest in merch by asking fans what items should be made next.",
  templateId: "favoriteMerchItems",
  template: (v, formState) => ({
    fields: {
      description: {
        content: {
          en: "Favorite Merch Items",
        },
      },
      ...getContestDefaults(formState),
    },
    ...(formState.hasSweeps === "Yes" && {
      flags: {
        showContestConfirmationMessage: true,
      },
    }),
  }),
  prompt: {
    promptId: (state) =>
      state.hasSweeps === "Yes"
        ? "pp-merch---fa-6b1dd9"
        : "pp-merch---fa-e7e523",
    fields: [
      {
        name: "hasSweeps",
        type: "radio",
        label: "Will you be offering a sweepstakes prize?",
        options: ["Yes", "No"],
        getValidation: (fields) =>
          !!fields.hasSweeps ? false : "You must select an option.",
      },
      {
        name: "prize",
        type: "text",
        label: "What's the prize?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.prize || fields.hasSweeps === "No"
            ? false
            : "This field cannot be left blank",
        isVisible: (form) => form.hasSweeps === "Yes",
      },
    ],
  },
};
